<div class="form-group">
    <label [for]="id" [ngClass]="{ 'text-danger': !valid}">{{label | translate}}</label>
    <input type="text" [id]="id" class="form-control" placeholder="{{correctPlaceHolder | translate}}"
        [(ngModel)]="value" [disabled]="disabled" [maxlength]="maxLength" [ngClass]="{ 'is-invalid': !valid}" int />
    <small *ngIf="!valid" class="form-text text-muted danger"><em>{{errorMessage}}</em></small>
</div>